var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Dashboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_1",
    "data-name": "Dashboard \\u2013 1",
    clipPath: "url(#clip-Dashboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grid",
    transform: "translate(-1 0.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(3 2.427)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(8.776 4.544) rotate(-45)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(9.653 9.08)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(3 9.08)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.d8b6521975148296a3cbd4584dc6ab34.svg";
export { ForwardRef as ReactComponent };